/**
 * Typed, centralized access to build-time env (injected by rspack DefinePlugin).
 * Never read import.meta.env.APP_* directly elsewhere — go through `env`.
 */
export const env = {
  appEnv: import.meta.env.APP_ENV || 'development',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,

  // DataCentral core API — v4 contract reused verbatim from datacentral-client-v4
  // (base already includes /api/v4). Every service call hits this host.
  dataCentralApiUrl: import.meta.env.APP_API_URL,
  // Shared service-management plane (v3) — same host @partner/@mgmt use.
  serviceApiV3Url: import.meta.env.APP_SERVICE_API_V3_URL,
  // Warehouse (v2), automation, healthcheck & alerting — direct Go/service hosts.
  warehouseApiUrl: import.meta.env.APP_WAREHOUSE_API_URL,
  automationApiUrl: import.meta.env.APP_AUTOMATION_API_URL,
  healthcheckApiUrl: import.meta.env.APP_HEALTHCHECK_API_URL,
  // AI assistant (n8n webhook) — Session-ID scoped, unauthenticated.
  assistantApiUrl: import.meta.env.APP_ASSISTANT_API_URL,

  livechat: {
    apiUrl: import.meta.env.APP_LIVECHAT_API_URL,
    socketUrl: import.meta.env.APP_LIVECHAT_SOCKET_URL,
  },

  storage: {
    baseUrl: import.meta.env.APP_STORAGE,
    rootPath: import.meta.env.APP_STORAGE_ROOT_PATH || 'pub/drives',
  },

  // Keycloak (realm `internal`) — the identity provider for staff/internal
  // accounts. Same realm datacentral-client-v4 authenticates against.
  keycloak: {
    url: import.meta.env.APP_KEYCLOAK_URL || 'https://id.vnetwork.dev',
    realm: import.meta.env.APP_KEYCLOAK_REALM || 'internal',
    clientId: import.meta.env.APP_KEYCLOAK_CLIENT_ID || 'datacentral',
    serverClientId:
      import.meta.env.APP_KEYCLOAK_SERVER_CLIENT_ID || 'datacentral-admin-console',
    redirectUri:
      import.meta.env.APP_KEYCLOAK_REDIRECT_URI ||
      `${window.location.origin}/auth/callback`,
  },

  // Default assignee employee ids for process/negotiation records (the backend
  // requires a non-empty assignee list). Mirrors legacy APP_PROCESS_ASSIGNEE_IDS.
  processAssigneeIds: String(import.meta.env.APP_PROCESS_ASSIGNEE_IDS || '79,321')
    .split(',')
    .map((s) => Number(s.trim()))
    .filter((n) => Number.isFinite(n)),

  partnerUrl: import.meta.env.APP_PARTNER_URL || 'https://partner.vnetwork.dev',
  reportUrl: import.meta.env.APP_REPORT_URL || 'https://report.vnetwork.dev',
  docsUrl:
    import.meta.env.APP_DOCUMENTATION_URL ||
    'https://production-dc-documentation.web.app/',

  sentryDsn: import.meta.env.APP_SENTRY_DSN || '',
} as const;

export type Env = typeof env;
